const TableSortDirection = {
  DEFAULT: 'desc',
};
export default TableSortDirection;
